import React from 'react';
import { concatStyles } from 'utils';
var HEADER_SECTION_TITLE_STYLES = 'normal-case text-primary font-body text-xl font-light mt-8 mr-0 mb-2 ml-0';
export var HeaderSectionTitle = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: concatStyles([HEADER_SECTION_TITLE_STYLES, className]) }, children));
};
HeaderSectionTitle.displayName = 'Content.HeaderSectionTitle';
